import { automationFullFragment } from './fragments';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const automationActivateAtom = createMutationAtomFactory(
  'automations.activate',
  (params: { id: string }) => ({
    automationsAutomationActivate: {
      __args: {
        id: params.id,
      },
      ...automationFullFragment,
    },
  }),
);
